import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { User } from '../models/user.model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DealerService {

  private _dealers: BehaviorSubject<User[]> = new BehaviorSubject([]);
  public readonly dealers: Observable<User[]> = this._dealers.asObservable();

  constructor(private api: ApiService) {
    this.loadDealers();
  }

  loadDealers() {
    this.api.getDealers().subscribe((dealers: User[]) => this._dealers.next(dealers));
  }

  resendActivationEmail(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.resendActivationEmail(id).subscribe(
        (dealer: User) => resolve(dealer)
      , (error => reject(error)));
    });
  }

  saveDealer(dealer: User): Promise<any> {
    return new Promise((resolve, reject) => {
      if (dealer.id) {
        this.api.putData('dealers', dealer).subscribe(result => {
          this.loadDealers();
          resolve(result);
        }, error => {
          this.loadDealers();
          reject(error);
        });
      } else {
        this.api.postData('dealers', dealer).subscribe(result => {
          this.loadDealers();
          resolve(result);
        }, error => {
          this.loadDealers();
          reject(error);
        });
      }
    });
  }

  deleteDealer(dealer: User): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.deleteData('dealers/' + dealer.id).subscribe(result => {
        this.loadDealers();
        resolve(result);
      }, error => {
        this.loadDealers();
        reject(error);
      });
    });
  }

}
